((document, $) => {
    function disableForm(this: HTMLFormElement, ev: SubmitEvent) {
        if (ev.defaultPrevented) {
            return false;
        }

        this.classList.add('was-validated');

        const validator = $ && $.fn.validate! && $(this).validate();
        if (this.checkValidity() === false || (validator && $(this).valid() === false)) {
            validator.form();
            ev.preventDefault();
            ev.stopPropagation();
            return false;
        }

        if (this.dataset.submitted) {
            ev.preventDefault();
            return false;
        }

        if (this.dataset.confirm && !confirm(this.dataset.confirm)) {
            ev.preventDefault();
            return false;
        }

        const btn = ev.submitter;
        if (btn) {
            btn.style.display = 'inline-block';
            btn.style.width = btn.clientWidth + 'px';
            btn.innerHTML = "<i class='fas fa-fw fa-circle-notch fa-spin'></i>";
            btn.classList.add("disabled");
        }

        this.dataset.submitted === "true";
        return true;
    }

    const forms = document.getElementsByTagName("form");

    for (let i = 0; i < forms.length; i++) {
        if (forms[i].dataset.disableOnSubmit != "off") {
            forms[i].addEventListener('submit', disableForm);
        }
    }
})(document, $);